(function () {
  function initMainProduct(root) {
    const section = root.matches('[data-main-product]') ? root : root.querySelector('[data-main-product]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const productJsonEl = section.querySelector('[data-product-json]');
    const product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

    initGallery(section);
    initAccordions(section);
    initQuantity(section);
    initStickyBar(section);
    initSpecialistLink(section);

    if (product) {
      initVariants(section, product);
    }
  }

  function openFreshChatWidget() {
    function tryOpenWidget() {
      if (window.fcWidget && typeof window.fcWidget.open === 'function') {
        window.fcWidget.open();
        return true;
      }

      return false;
    }

    function tryClickLauncher() {
      const launcher = document.querySelector('.d-hotline.h-btn, .fc-widget-launcher, #fc_frame');
      if (!launcher) return false;
      launcher.click();
      return true;
    }

    if (tryOpenWidget() || tryClickLauncher()) return;

    if (window.fcWidget && typeof window.fcWidget.on === 'function') {
      window.fcWidget.on('widget:loaded', tryOpenWidget);
    }

    if (typeof window.initiateCall === 'function') {
      window.initiateCall();
    }

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryOpenWidget() || tryClickLauncher() || attempts >= 24) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function initSpecialistLink(section) {
    const trigger = section.querySelector('[data-specialist-hotline-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openFreshChatWidget();
    });
  }

  function initStickyBar(section) {
    const bar = section.querySelector('[data-sticky-bar]');
    const anchor = section.querySelector('[data-purchase-anchor]');
    if (!bar) return;

    if (!anchor) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = !entry.isIntersecting;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
      },
      { threshold: 0 }
    );

    observer.observe(anchor);
  }

  function initGallery(section) {
    if (typeof Swiper === 'undefined') return;

    const mainEl = section.querySelector('.main-product__gallery-main');
    const thumbsEl = section.querySelector('.main-product__thumbs');
    if (!mainEl || !thumbsEl) return;

    const counterEl = section.querySelector('[data-media-counter]');
    const captionEl = section.querySelector('[data-media-caption]');
    const defaultCaption = captionEl?.dataset.defaultCaption || '';

    const thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        prevEl: section.querySelector('.main-product__thumb-prev'),
        nextEl: section.querySelector('.main-product__thumb-next'),
      },
    });

    const mainSwiper = new Swiper(mainEl, {
      spaceBetween: 0,
      thumbs: {
        swiper: thumbsSwiper,
      },
      on: {
        slideChange(swiper) {
          updateMediaMeta(swiper.activeIndex);
        },
      },
    });

    function updateMediaMeta(index) {
      const slide = mainSwiper.slides[index];
      if (!slide) return;

      if (counterEl) {
        counterEl.textContent = `${index + 1} / ${mainSwiper.slides.length}`;
      }

      if (captionEl) {
        const alt = slide.dataset.mediaAlt || '';
        captionEl.textContent = alt || defaultCaption;
      }
    }

    updateMediaMeta(mainSwiper.activeIndex);
    section._mainProductSwiper = mainSwiper;
  }

  function initAccordions(section) {
    section.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const accordion = toggle.closest('[data-accordion]');
        if (!accordion) return;

        const isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initQuantity(section) {
    const input = section.querySelector('[data-qty-input]');
    if (!input) return;

    section.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
      const value = Math.max(1, Number(input.value) - 1);
      input.value = String(value);
    });

    section.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
      const value = Math.max(1, Number(input.value) + 1);
      input.value = String(value);
    });
  }

  function initVariants(section, product) {
    const variantInput = section.querySelector('[data-variant-id]');
    const optionButtons = section.querySelectorAll('[data-option-value]');
    const priceEl = section.querySelector('[data-product-price]');
    const compareEl = section.querySelector('[data-product-compare-price]');
    const saveEl = section.querySelector('[data-product-save]');
    const skuEl = section.querySelector('[data-product-sku]');
    const addBtn = section.querySelector('[data-add-to-cart]');
    const stickyAddBtn = section.querySelector('[data-sticky-add-to-cart]');
    const stickyAddLabel = section.querySelector('[data-sticky-add-label]');
    const buyNowWrap = section.querySelector('[data-buy-now-wrap]');
    const stickyPriceEls = section.querySelectorAll('[data-sticky-price]');
    const stickyCompareEl = section.querySelector('[data-sticky-compare-price]');
    const stickyVariantEl = section.querySelector('[data-sticky-variant]');
    const stickyImageEl = section.querySelector('.main-product__sticky-image');

    const options = product.options.map((name, index) => ({
      name,
      values: [...new Set(product.variants.map((variant) => variant.options[index]).filter(Boolean))],
    }));

    const selectedOptions = options.map((option, index) => {
      const selected = section.querySelector(
        `[data-option-value][data-option-index="${index}"].is-selected`
      );
      return selected ? selected.dataset.value : option.values[0];
    });

    function findVariant() {
      return product.variants.find((variant) =>
        variant.options.every((value, index) => value === selectedOptions[index])
      );
    }

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
      }

      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: 'USD',
      });
    }

    function updateAvailability(variant) {
      const available = variant && variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available
          ? addBtn.dataset.labelAvailable || addBtn.textContent
          : addBtn.dataset.labelSoldOut || 'Sold out';
      }

      if (stickyAddBtn) {
        stickyAddBtn.disabled = !available;
      }

      if (stickyAddLabel) {
        stickyAddLabel.textContent = available
          ? stickyAddBtn?.dataset.labelAvailable || stickyAddLabel.textContent
          : stickyAddBtn?.dataset.labelSoldOut || 'Sold out';
      }

      if (buyNowWrap) {
        buyNowWrap.hidden = !available;
      }
    }

    function updatePrice(variant) {
      if (!variant) return;

      const formattedPrice = formatMoney(variant.price);

      if (priceEl) {
        priceEl.textContent = formattedPrice;
      }

      stickyPriceEls.forEach((el) => {
        el.textContent = formattedPrice;
      });

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
      }

      if (stickyCompareEl) {
        stickyCompareEl.hidden = !onSale;
        if (onSale) stickyCompareEl.textContent = formatMoney(variant.compare_at_price);
      }

      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) {
          const saveAmount = variant.compare_at_price - variant.price;
          saveEl.textContent = `${saveEl.dataset.saveLabel || 'Save'} ${formatMoney(saveAmount)}`;
        }
      }
    }

    function updateStickyVariant(variant) {
      if (!stickyVariantEl || !variant) return;

      const options = variant.options.filter(Boolean).join(' · ');
      stickyVariantEl.textContent = options ? ` · ${options}` : '';
      stickyVariantEl.hidden = !options;
    }

    function updateStickyImage(variant) {
      if (!stickyImageEl || !variant?.featured_image?.src) return;

      stickyImageEl.src = variant.featured_image.src;
      stickyImageEl.removeAttribute('srcset');
    }

    function updateSku(variant) {
      if (skuEl && variant) {
        skuEl.textContent = variant.sku ? `SKU ${variant.sku}` : '';
        skuEl.hidden = !variant.sku;
      }
    }

    function updateVariantId(variant) {
      if (variantInput && variant) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function refreshOptionStates() {
      options.forEach((option, optionIndex) => {
        option.values.forEach((value) => {
          const button = section.querySelector(
            `[data-option-value][data-option-index="${optionIndex}"][data-value="${CSS.escape(value)}"]`
          );
          if (!button) return;

          const trialOptions = [...selectedOptions];
          trialOptions[optionIndex] = value;
          const matchingVariant = product.variants.find((variant) =>
            variant.options.every((optionValue, index) => optionValue === trialOptions[index])
          );

          button.disabled = !matchingVariant || !matchingVariant.available;
          button.classList.toggle('is-selected', selectedOptions[optionIndex] === value);
        });
      });
    }

    function applyVariant(variant) {
      updateVariantId(variant);
      updatePrice(variant);
      updateSku(variant);
      updateAvailability(variant);
      updateStickyVariant(variant);
      updateStickyImage(variant);
      refreshOptionStates();
    }

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;

        const optionIndex = Number(button.dataset.optionIndex);
        selectedOptions[optionIndex] = button.dataset.value;

        const variant = findVariant();
        if (variant) applyVariant(variant);
      });
    });

    const initialVariant =
      product.variants.find((variant) => variant.id === Number(variantInput?.value)) ||
      product.variants.find((variant) => variant.available) ||
      product.variants[0];

    if (initialVariant) {
      initialVariant.options.forEach((value, index) => {
        selectedOptions[index] = value;
      });
      applyVariant(initialVariant);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-main-product]').forEach(initMainProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-main-product]');
    if (section) {
      section.dataset.initialized = 'false';
      initMainProduct(section);
    }
  });
})();
